export default "__VITE_ASSET__CwqpA84p__"